import React, { useState } from 'react'
import { bool, string } from 'prop-types'
import { Button } from '@planningcenter/tapestry-react'
import { ThemeProvider } from './ThemeProvider'
import CopyToClipboard from 'react-copy-to-clipboard'

export default function CopyButton({
  copyValue = '',
  iconOnly = true,
  ...buttonProps
}) {
  const [copied, setCopied] = useState(false)

  const getIcon = () =>
    copied ? 'general.check' : 'general.outlinedTwoBlankFiles'

  const getDisplayText = () => (copied ? 'Copied' : 'Copy')
  const getTooltip = () => (copied ? 'Copied' : 'Copy to clipboard')

  return (
    <ThemeProvider>
      <CopyToClipboard
        text={copyValue}
        onCopy={() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 2000)
        }}
      >
        <Button
          theme="interaction"
          variant="outline"
          size="sm"
          icon={iconOnly ? getIcon() : null}
          iconLeft={!iconOnly ? getIcon() : null}
          tooltip={{
            title: iconOnly ? getTooltip() : null,
            placement: iconOnly ? 'top' : null,
          }}
          {...buttonProps}
        >
          {!iconOnly ? getDisplayText() : null}
        </Button>
      </CopyToClipboard>
    </ThemeProvider>
  )
}

CopyButton.propTypes = {
  copyValue: string.isRequired,
  iconOnly: bool,
}
